<template>
  <div>
      <Head :title="__(title)" />
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="update">
          <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
            <select-input v-model="form.parent_id" :error="form.errors.parent_id" class="pr-6 pb-8 w-full" :label="__('Padre')">
                          <option :value="null" />
                          <option v-for="s in padres" :key="s.id" :value="s.id">{{ s.name }}</option>
          </select-input>
          <text-input v-model="form.name" :error="form.errors.name" class="pr-6 pb-8 w-full " :label="__('Name')" />
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
          <button class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Eliminar categoría</button>
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Actualizar categoría</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import { Link, Head } from '@inertiajs/inertia-vue3'
import SelectInput from '@/Shared/SelectInput'

export default {
  metaInfo() {
    return { title: this.form.name }
  },
  components: {
    LoadingButton,
    TextInput,
      Link,
      Head,
      SelectInput
  },
  layout: Layout,
  props: {
    name: String,
    padres: Object,
    item: Object,
    parent_id : ''
  },
  remember: 'form',
  data() {
       
    return {
      form: this.$inertia.form({
          name: this.item.name,
          parent_id: this.item.parent_id
      }),
    }
  }, 
  methods: {
    update() {
      this.form.put(this.route('list.update', this.item.id))
    },
    destroy() {
      if (confirm('Are you sure you want to delete this category?')) {
        this.$inertia.delete(this.route('list.destroy', this.item.id))
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this category?')) {
       this.$inertia.put(this.route('list.restore', this.item.id))
      }
    },
  },
}
</script>
